import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package } from "lucide-react";
import { api, productThumb } from "../../lib/api";

export default function BoxOptionsStrip({ currentSlug, serviceCategory, subCategory }) {
  const [boxes, setBoxes] = useState([]);
  useEffect(() => {
    api.get("/products", { params: { service_category: serviceCategory, sub_category: subCategory } })
      .then(({ data }) => setBoxes(data.filter((p) => p.layout === "box-configurator").slice(0, 8)))
      .catch(() => {});
  }, [serviceCategory, subCategory]);
  if (!boxes.length) return null;
  return (
    <div className="border-b border-slate-200 bg-white" data-testid="box-options-strip">
      <div className="container-page flex items-center gap-6 overflow-x-auto py-3">
        <span className="overline whitespace-nowrap shrink-0">Explore our box options</span>
        <div className="flex items-stretch gap-2">
          {boxes.map((b) => {
            const active = b.slug === currentSlug;
            return (
              <Link
                key={b.slug}
                to={`/shop/product/${b.slug}`}
                data-testid={`box-option-${b.slug}`}
                className={`flex items-center gap-3 px-3 py-2 border-b-2 transition-colors whitespace-nowrap ${
                  active ? "border-kolt-orange text-kolt-orange" : "border-transparent text-slate-600 hover:text-kolt-slate hover:border-slate-300"
                }`}
              >
                <span className="w-9 h-9 bg-slate-50 border border-slate-200 grid place-items-center overflow-hidden shrink-0">
                  {b.image_url ? (
                    <img src={productThumb(b.image_url, 120)} alt="" className="w-full h-full object-cover" loading="lazy" />
                  ) : (
                    <Package className="w-4 h-4 text-slate-400" />
                  )}
                </span>
                <span className="text-xs font-semibold leading-tight max-w-[110px] whitespace-normal">{b.name.replace(/^Custom /, "")}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
